var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirplane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "#888",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.186 0.252942L0.935811 9.62413C-0.407952 10.4015 -0.279045 12.3898 1.15847 12.9796L5.62336 14.8273V18.1242C5.62336 19.9367 7.93588 20.6828 9.0062 19.2414L10.7172 16.9328L15.0883 18.7375C15.3188 18.8313 15.561 18.8781 15.8031 18.8781C16.1235 18.8781 16.4399 18.7961 16.725 18.6359C17.225 18.3547 17.5688 17.8547 17.6586 17.2883L19.979 2.16312C20.2173 0.596695 18.5375 -0.52441 17.186 0.252942ZM7.49838 18.1242V15.6007L8.92808 16.1906L7.49838 18.1242ZM15.8031 17.0031L9.79527 14.5226L15.2719 6.62019C15.6899 6.01472 14.9008 5.31159 14.3461 5.79206L6.0843 12.9914L1.87332 11.2491L18.1235 1.87405L15.8031 17.0031Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.eec589f7515af9b5282a87eb347830a4.svg";
export { ForwardRef as ReactComponent };